import { Link } from 'react-router-dom';

import ListItem from './ListItem';
import BookImage from './BookImage';
import Icon from './Icon';
import Text from './Text';
import { useTheme } from 'styled-components';

const ProductListItem = ({
  product,
  after,
  linkTo,
  backgroundColor,
  className,
}) => {
  const theme = useTheme();

  const imageSource = product.thumbnail;

  const { title, subtitle, author, isbn } = product;

  return (
    <Link
      key={`product-${product.id}`}
      to={linkTo || `/products?i=${product.id}`}
      style={{
        color: 'black',
      }}
    >
      <ListItem
        style={{
          backgroundColor,
        }}
        className={className}
        key={product.id.toString()}
        before={
          <BookImage bookId={product.id} source={imageSource} size={60} />
        }
        after={
          after || (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                height: 'inherit',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: 10,
              }}
            >
              <Icon
                name="chevron-right-outline"
                color={theme.colors.mediumGrayColor}
                size={32}
              />
            </div>
          )
        }
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100%',
            marginLeft: 10,
            overflow: 'hidden',
          }}
        >
          <Text variant="listItemTitle">{`${title}${
            subtitle ? ` - ${subtitle}` : ``
          }`}</Text>

          {author && <Text variant="listItemSubtitle">av {author}</Text>}

          {isbn && <Text variant="listItemTag">ISBN {isbn}</Text>}
        </div>
      </ListItem>
    </Link>
  );
};

ProductListItem.defaultProps = {
  showBorder: true,
  showCreated: true,
  showPrice: true,
};

export default ProductListItem;
